export default "__VITE_ASSET__Dx$rChLs__"